import DomainStorage from "domain-storage/lib/DomainStorage"

export const useDomainStorage = () => {
  if (DomainStorage.getServerUrl() === undefined) {
    DomainStorage.setServerUrl(process.env.REACT_APP_DS_SERVER_URL)
  }

  return DomainStorage
}
